import { DesktopGameProfileVerification } from '../../game-profile/desktop/DesktopGameProfileVerification.jsx';
import { CommunityTypePicker } from '../shared/CommunityTypePicker.jsx';
import { CurrentUnionSettings } from '../../game-profile/shared/CurrentUnionSettings.jsx';
import { DoroPartyWordmark } from '../../../shared/ui/DoroPartyWordmark.jsx';
import { SiteFooter } from '../../../shared/ui/SiteFooter.jsx';
import { SupabaseStatus } from '../../../shared/ui/SupabaseStatus.jsx';

function EntryHeader({ onSignOut }) {
  return (
    <header className="desktop-entry-topbar">
      <div className="desktop-entry-brand">
        <div><DoroPartyWordmark compact /><strong>NIKKE UNION RAID PLATFORM</strong></div>
      </div>
      <div className="desktop-entry-account"><SupabaseStatus /><span>개인 코드 계정</span><button type="button" onClick={onSignOut}>로그아웃</button></div>
    </header>
  );
}

function ProfileSummary({ profile }) {
  return <div className="desktop-entry-profile-summary"><div><span>인증된 게임 계정</span><strong>{profile?.nickname || '닉네임 확인 완료'}</strong></div><div><span>확인된 유니온</span><strong>{profile?.guild_name || '유니온명 확인 필요'}</strong></div></div>;
}

function OnboardingChoice({ entry }) {
  const isAutoJoining = Boolean(entry.matchingUnion?.id);
  const canRegister = Boolean(entry.profile?.guild_name) && !entry.matchingUnion;
  const hasGuild = Boolean(entry.profile?.guild_id);

  return (
    <section className="desktop-entry-panel desktop-entry-choice" aria-label="유니온 연결">
      <div className="desktop-entry-panel-heading"><div><p>UNION ONBOARDING</p><h1>{isAutoJoining ? '등록 유니온으로 자동가입 중입니다.' : '유니온 등록을 신청하세요.'}</h1><span>BlablaLink에서 확인한 실제 소속 유니온을 기준으로 처리합니다.</span></div><b>02</b></div>
      <ProfileSummary profile={entry.profile} />
      {!hasGuild ? <p className="desktop-entry-inline-notice warning">BlablaLink에서 유니온 소속이 확인되지 않았습니다. 게임 프로필의 유니온 정보를 확인한 뒤 다시 시도해주세요.</p> : null}
      <div className="desktop-entry-choice-grid single-path">
        {isAutoJoining ? (
          <article className="available"><div className="desktop-entry-choice-icon" aria-hidden="true">A</div><span>AUTO JOIN</span><h2>{entry.matchingUnion.name} 연결 중</h2><p>이미 등록된 유니온이므로 별도 승인 없이 자동으로 가입합니다.</p><button type="button" disabled>자동가입 처리 중…</button></article>
        ) : (
          <article className={canRegister ? 'available leader' : 'disabled'}><div className="desktop-entry-choice-icon" aria-hidden="true">U</div><span>NEW UNION</span><h2>DoroParty 유니온 등록</h2><p>{entry.profile?.guild_name ? `${entry.profile.guild_name}이 아직 등록되지 않았습니다. 승인 후 신청자가 주딱으로 시작합니다.` : '유니온 등록을 위해 유니온명 확인이 필요합니다.'}</p>{canRegister ? <CommunityTypePicker idPrefix="desktop-entry" value={entry.communityType} onChange={entry.setCommunityType} disabled={Boolean(entry.working)} /> : null}<button type="button" disabled={!canRegister || !entry.communityType || Boolean(entry.working)} onClick={() => entry.registerNewUnion()}>{entry.working === 'registration' ? '등록 신청 중…' : !canRegister ? '유니온 등록 불가' : !entry.communityType ? '커뮤니티 유형을 선택하세요' : `${entry.profile.guild_name} 등록 신청`}</button></article>
        )}
      </div>
      {entry.notice.message ? <p className={`desktop-entry-inline-notice ${entry.notice.type}`} role="status">{entry.notice.message}</p> : null}
      <button className="desktop-entry-refresh" type="button" onClick={() => entry.refresh()}>상태 다시 확인</button>
    </section>
  );
}

function PendingState({ entry }) {
  const isLeader = entry.membership?.role === 'leader';
  const unionName = entry.union?.name || entry.profile?.guild_name || '유니온';
  return <section className="desktop-entry-panel desktop-entry-pending" aria-label="유니온 처리 대기"><div className="desktop-entry-pending-mark" aria-hidden="true">…</div><p>WAITING FOR APPROVAL</p><h1>{isLeader ? '유니온 등록 승인 대기' : '유니온 가입 처리 대기'}</h1><strong>{unionName}</strong><span>{isLeader ? '플랫폼 승인 후 자동으로 내 유니온 레이드 현황으로 이동합니다.' : '가입 처리가 끝나면 자동으로 유니온 페이지로 이동합니다.'}</span><button type="button" onClick={() => entry.refresh()}>지금 다시 확인</button></section>;
}

function BlockedState({ entry }) {
  return <section className="desktop-entry-panel desktop-entry-pending blocked" aria-label="유니온 이용 제한"><div className="desktop-entry-pending-mark" aria-hidden="true">!</div><p>UNION STATUS</p><h1>현재 유니온 페이지를 열 수 없습니다.</h1><strong>{entry.union?.name || entry.profile?.guild_name || '유니온 상태 확인 필요'}</strong><span>유니온 상태가 다시 활성화되면 자동으로 정상 화면으로 이동합니다.</span><button type="button" onClick={() => entry.refresh()}>상태 다시 확인</button></section>;
}

export function DesktopEntryGate({ onSignOut, entry }) {
  return (
    <div className="desktop-entry-shell">
      <EntryHeader onSignOut={onSignOut} />
      <main className="desktop-entry-main">
        {entry.mode === 'loading' ? <section className="desktop-entry-loading" role="status"><span aria-hidden="true" /><div><strong>계정 상태 확인 중</strong><p>게임 프로필과 유니온 정보를 불러오고 있습니다.</p></div></section> : null}
        {entry.mode === 'error' ? <section className="desktop-entry-panel desktop-entry-error" role="alert"><strong>진입 정보를 확인하지 못했습니다.</strong><p>{entry.error}</p><button type="button" onClick={() => entry.refresh()}>다시 시도</button></section> : null}
        {entry.mode === 'profile' ? <><section className="desktop-entry-welcome"><p>STEP 01</p><h1>BlablaLink 게임 프로필을 인증하세요.</h1><span>게임 계정과 소속 유니온 확인 후 자동가입 또는 유니온 등록 신청으로 이어집니다.</span></section><DesktopGameProfileVerification /></> : null}
        {entry.mode === 'onboarding' ? <OnboardingChoice entry={entry} /> : null}
        {entry.mode === 'pending' ? <PendingState entry={entry} /> : null}
        {entry.mode === 'blocked' ? <BlockedState entry={entry} /> : null}
        {entry.profile && ['pending', 'blocked', 'onboarding'].includes(entry.mode) ? <CurrentUnionSettings entry={entry} /> : null}
      </main>
      <SiteFooter compact />
    </div>
  );
}
